export const PAGE_NAME = "forgot-page";

export enum ForgotComponent {
  email = "email",
  verification = "verification",
  password = "password",
}
